import { Icon, IconButton, makeStyles, TextField, Tooltip } from '@material-ui/core';
import { emailIsValid } from 'helpers/functions';
import React, { Fragment, memo, useCallback, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { useCallbackObservable } from 'react-use-observable';
import { tap } from 'rxjs/operators';
import MyModal from 'v2/components/Shared/MyModal';
import PermissionHide from 'v2/components/Shared/PermissionHide';
import { useModal } from 'v2/hooks/useModal';
import subscriptionsService from 'v2/services/subscriptions';

import type { ISubscriptions } from 'v2/interfaces/subscriptions';

interface IProps {
  contract: ISubscriptions;
}

const useStyles = makeStyles(() => ({
  icon: {
    fontSize: 17,
    color: '#596375',
  },
  iconButton: {
    width: 40,
    height: 40,
  },
}));

const ChangeChargeEmail = memo(({ contract }: IProps) => {
  const classes = useStyles();
  const [openModal, setOpenModal] = useModal();
  const [newChargeEmail, setNewChargeEmail] = useState('');
  const [inputFocus, setInputFocus] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [chargeEmail, setChargeEmail] = useState(contract?.charge_email || ' - ');

  const getErrorForField = useMemo(() => {
    if (!inputFocus) {
      return false;
    }

    return !emailIsValid(newChargeEmail);
  }, [inputFocus, newChargeEmail]);

  const handleChangeFieldChargeEmail = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setNewChargeEmail(e.target.value);
  }, []);

  const [handleClickChangeEmail] = useCallbackObservable(() => {
    setIsSubmitting(true);
    return subscriptionsService.changeChargeEmail(contract.id, newChargeEmail).pipe(
      tap(
        () => {
          setChargeEmail(newChargeEmail);
          setIsSubmitting(false);
          setNewChargeEmail('');
          setOpenModal();
          toast.success('E-mail alterado com sucesso');
        },
        (err) => {
          setIsSubmitting(false);
          toast.error(err);
        }
      )
    );
  }, [newChargeEmail, contract]);

  const isDisabled = getErrorForField || isSubmitting;

  return (
    <Fragment>
      <MyModal
        title='Alterar E-mail de Cobrança'
        submitDisabled={isDisabled}
        opened={openModal}
        onClose={setOpenModal}
        onSubmit={handleClickChangeEmail}
      >
        <TextField
          fullWidth
          placeholder='Novo e-mail de cobrança'
          onChange={handleChangeFieldChargeEmail}
          onFocus={() => setInputFocus(true)}
          helperText={getErrorForField ? 'Digite um e-mail válido' : ''}
          error={getErrorForField}
          value={newChargeEmail}
        />
      </MyModal>

      <div>
        <span>E-mail de cobrança: &nbsp;</span>
        {chargeEmail}
        <PermissionHide action='myeduzz:meus-contratos:editar'>
          <Tooltip placement='top' title='Alterar e-mail de cobrança'>
            <IconButton className={classes.iconButton} onClick={setOpenModal}>
              <Icon className={classes.icon}>edit</Icon>
            </IconButton>
          </Tooltip>
        </PermissionHide>
      </div>
    </Fragment>
  );
});

export default ChangeChargeEmail;
